import styled from 'styled-components'

export default styled.h4`
  display: block;
  font-size: 18px;
  color: #767676;
  font-weight: 400;
`
